//imports
import {
    JIRA_SUMMARY_SEARCH_REQUEST,
    JIRA_SUMMARY_SEARCH_RESULT,
} from 'Redux/actionTypes';

export const jiraSummarySearchRequest = (filters) => ({
    type: JIRA_SUMMARY_SEARCH_REQUEST,
    payload: filters,
});

export const jiraSummarySearchResult = (data) => ({
    type: JIRA_SUMMARY_SEARCH_RESULT,
    payload: data,
});


